const RANKING = [
  {
    rank: 1,
    title: '流浪地球3',
    info: '科幻巨制 · 2026年度最受期待',
    tag: '热映中',
    extra: '豆瓣8.6',
  },
  {
    rank: 2,
    title: '封神第二部',
    info: '奇幻史诗 · 国产神话大片',
    tag: '新上',
    extra: '票房冠军',
  },
  {
    rank: 3,
    title: '奥本海默',
    info: '诺兰导演 · 传记历史经典',
    tag: '经典',
    extra: '奥斯卡最佳',
  },
  {
    rank: 4,
    title: '速度与激情11',
    info: '动作冒险 · 系列终章之作',
    tag: '热门',
    extra: '全网热搜',
  },
  {
    rank: 5,
    title: '熊出没·重启未来',
    info: '合家欢动画 · 国产动画票房',
    tag: '推荐',
    extra: '家庭首选',
  },
  {
    rank: 6,
    title: '周处除三害',
    info: '犯罪动作 · 口碑黑马',
    tag: '精选',
    extra: '年度口碑',
  },
  {
    rank: 7,
    title: '热辣滚烫',
    info: '喜剧励志 · 热门话题之作',
    tag: '',
    extra: '口碑佳作',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            全网热搜电影实时排行，看看大家都在看什么
          </p>
        </div>

        <div className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
          {RANKING.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 ${
                i < RANKING.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <span
                className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-secondary-400 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-300 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800">
                    {item.title}
                  </h3>
                  {item.tag && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.info}</p>
              </div>

              <span className="flex-shrink-0 text-xs md:text-sm font-medium text-accent-700 whitespace-nowrap">
                {item.extra}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}